import React, { useRef, useState } from "react";
import "./ThirdPartyItem.css";
import useOutsideClick from "../../../Custom Hooks/useOutsideClick";

const ThirdPartyItem = ({ item = "Title", status = "Ordered" }) => {
  const [hoverStatus, setHoverStatus] = useState("hidden");
  const ref = useRef();

  useOutsideClick(ref, () => {
    setHoverStatus("hidden");
  });

  return (
    <>
      <div className="thirdPartyProgress">
        <span className={`thirdPartyHover ${hoverStatus}`}>
          {item} {status}
        </span>
        <span className="thirdPartyLetter">{item[0]}</span>
        <svg
          className="circle-container"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
          ref={ref}
          onClick={() => {
            hoverStatus === "hidden"
              ? setHoverStatus("")
              : setHoverStatus("hidden");
          }}
        >
          <circle
            id="prioritizeClick"
            className="pending"
            cx="50"
            cy="50"
            r="45"
          />
          {status === "Received" ||
          status === "Waiver" ||
          status === "Condo Simply Approved" ? (
            <circle
              id="prioritizeClick"
              className="full"
              cx="50"
              cy="50"
              r="45"
            />
          ) : null}
          {status === "Scheduled" ? (
            <circle
              id="prioritizeClick"
              className="twoThirds-full"
              cx="50"
              cy="50"
              r="45"
            />
          ) : null}
          {status === "Ordered" ? (
            <circle
              id="prioritizeClick"
              className="half-full"
              cx="50"
              cy="50"
              r="45"
            />
          ) : null}
        </svg>
      </div>
    </>
  );
};

export default ThirdPartyItem;
